import { useEffect } from "react"
import localforage from "localforage";
import tokenService from "../../../../utils/tokenService";


const Logout = () => {
    // const askLogout = () => {
    //     Swal.fire({
    //       title: "ต้องการออกจากระบบ ?",
    //       text: "การที่คุณออกจากระบบจะไม่สามารถใช้งานฟังก์ชั่นบางอย่างได้!",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#34BFD9",
    //       cancelButtonColor: "#000",
    //       confirmButtonText: "ยืนยันการออกจากระบบ!",
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         Swal.fire("สำเร็จ!", "ออกจากระบบเรียบร้อย", "success");
    //         Cookies.remove("jwt");
    //         window.location.reload();
    //       }
    //     });
    //   };
    useEffect(() => {
        const performLogout = async () => {
            try {
                // ทางเดียวของการออกจากระบบ: เพิกถอนฝั่ง server + ล้างเครื่องให้หมด
                await tokenService.logout();

                // Clear upload data
                await localforage.removeItem("uploadData");

                window.location.replace('/login');
            } catch (err) {
                console.error("Error during logout:", err);
                tokenService.clearToken();
                window.location.replace('/login');
            }
        };

        performLogout();
    }, [])
    return (
        <div className="w-screen h-screen flex justify-center items-center">กำลังออกจากระบบ..</div>
    )
}

export default Logout   